import { axiosClient } from '../../../../services/axiosInstance'
import { OrderForm } from '../../entity/orderForm'

export const removeCartProfile = async (orderFormId: string) => {
  const { data } = await axiosClient.get(
    `/api/checkout/changeToAnonymousUser/${orderFormId}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  )

  return new OrderForm(data)
}
